export default __webpack_public_path__ + "static/media/Id_Verification.2239c7e2.png";